import { BasicObject } from '../uiObjects/basicObject';

import { Direction } from './direction';
import { Line } from './Line';

export abstract class MathObject extends BasicObject {
  // The line of MathObjects that this MathObject belongs to.
  line?: Line;
  // legacy naming, 'editable'
  e?: boolean;

  // Multi had this property in the megafile, used by Root
  isOptional?: boolean;

  t: string;

  constructor(x = 0, y = 0) {
    super(x, y);

    this.t = 'generic MathObject, child t should set this';
    this.gmmName = 'generic MathObject, child gmmName should set this';
  }

  setLine(line: Line): void {
    this.line = line;
  }

  getValueChildren(): MathObject[] {
    return this.children as MathObject[];
  }

  getValueParent(): MathObject | undefined {
    return this.parent as MathObject | undefined;
  }

  getValueGrandparent(): MathObject | undefined {
    return this.parent?.parent as MathObject | undefined;
  }

  isBaselineAware(): boolean {
    return true;
  }

  countMiddleSymbols(): number {
    let count = 0;

    for (let i = 0; i < this.getValueChildren().length; i++) {
      count += this.getValueChildren()[i].countMiddleSymbols();
    }

    return count;
  }

  findAnyChildFont(): string | undefined {
    const stack = [...this.getValueChildren()];

    while (stack.length) {
      const node = stack.pop()!;
      const c = node as any;

      if (c.font) return c.font;
      stack.push(...node.getValueChildren());
    }

    return undefined;
  }

  abstract toXML(): string;

  // Extensions of MathObject override these methods as needed
  buildSizeRecursive(): void {}
  setEditable(_editable: boolean): void {}
  setFont(_font: string): void {}
  grabFocus(_dir?: Direction): void {}

  swapString(_old: string, _replacer: string): void {}
  childSizeChanged(): void {}
  buildSize(): void {}
  setPositionsOfChildren(): void {}
}

/**
 * Distance from left side of ancestor to left side of child.
 * Note: if ancestor is not actually an ancestor of child, this will
 * return the distance up to the highest ancestor found.
 * @param child Child
 * @param ancestor Ancestor
 * @returns Distance
 */
export function viewportXToAncestor(
  child: BasicObject,
  ancestor: BasicObject,
  maxHops = 1000
): number {
  let x = child.viewportX;
  let current: BasicObject = child;

  let hops = 0;

  while (current && current !== ancestor && hops < maxHops) {
    const parent = current.parent;

    if (!parent) break;

    x += parent.viewportX;

    current = parent;
    hops++;
  }

  if (hops >= maxHops) {
    console.error(
      'viewportXToAncestor: max hops reached, possible cycle in parent chain'
    );
  }

  return x;
}
